export default __webpack_public_path__ + "static/media/s2.097f2818.svg";